module.exports = __webpack_public_path__ + "static/media/trans.32a2bd36.png";